import { responsiveVanillaSelector, forumSelector } from '../selectors';
import type { Site } from '../Site';

export const TomsGuide: Site = {
  id: 'tomsguide',
  logo: 'svg/tomsguide.svg',
  label: "Tom's Guide",
  analyticsName: 'tomsguide',
  hostname: 'tomsguide.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, ${forumSelector}, #widgetArea12 a.visit-site-test`,
};
